import React from 'react';
import { Building2, Award, Globe2, Users, Clock, Stethoscope } from 'lucide-react';
import './Taipeiims.css';

const Taipeiims: React.FC = () => {
  return (
    <div className="taipeiims">
      {/* Hero Section */}
      <div className="hero">
        <div className="hero-overlay"></div>
        <div className="hero-content">
          <h1>Taipei Global Medical Tourism</h1>
          <p>World-Class Healthcare in the Heart of Asia</p>
        </div>
      </div>

      {/* Introduction Section */}
      <section className="intro-section container">
        <div className="intro-content">
          <div className="intro-text">
            <h2>Welcome to Taipei Medical Excellence</h2>
            <p>
              Experience world-renowned medical care in Taipei, where cutting-edge technology meets 
              traditional hospitality. Our internationally accredited hospitals and specialized medical 
              centers offer comprehensive healthcare services with the highest standards of quality and safety.
            </p>
          </div>
          <div className="intro-image">
            <img 
              src="https://images.unsplash.com/photo-1538108149393-fbbd81895907?auto=format&fit=crop&q=80&w=2000"
              alt="Taipei Medical Center"
              loading="lazy"
            />
          </div>
        </div>
      </section>

      {/* Wellness Section */}
      <section className="wellness-section container">
        <h2>Wellness & Cultural Experiences</h2>
        <div className="wellness-grid">
          <div className="wellness-card">
            <h3>Clean Eating Guide</h3>
            <div className="video-container">
              <iframe
                src="https://www.youtube.com/embed/tQSNAgq7DPc"
                title="Clean Eating Guide 1"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              ></iframe>
            </div>
            <div className="video-container">
              <iframe
                src="https://www.youtube.com/embed/uo-gmylvxD8"
                title="Clean Eating Guide 2"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              ></iframe>
            </div>
          </div>
          <div className="wellness-card">
            <h3>Nongchan Temple Experience</h3>
            <div className="video-container">
              <iframe
                src="https://www.youtube.com/embed/I1WGAzyw8a8"
                title="Nongchan Temple"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              ></iframe>
            </div>
          </div>
          <div className="wellness-card">
            <h3>Tai Chi Practice</h3>
            <div className="video-container">
              <iframe
                src="https://www.youtube.com/embed/j7zKkcVMaq8"
                title="Tai Chi"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              ></iframe>
            </div>
          </div>
          <div className="wellness-card">
            <h3>Yilan Homestay Experience</h3>
            <div className="video-container">
              <iframe
                src="https://www.youtube.com/embed/y-CPAEpdkZA"
                title="Yilan Homestay"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              ></iframe>
            </div>
          </div>
        </div>
      </section>

      {/* Features Grid */}
      <section className="features-section container">
        <div className="features-grid">
          <div className="feature-card">
            <Building2 className="feature-icon" />
            <h3>State-of-the-Art Facilities</h3>
            <p>Advanced medical centers equipped with the latest technology and modern amenities</p>
          </div>
          <div className="feature-card">
            <Award className="feature-icon" />
            <h3>International Accreditation</h3>
            <p>JCI-accredited hospitals maintaining the highest global healthcare standards</p>
          </div>
          <div className="feature-card">
            <Globe2 className="feature-icon" />
            <h3>Multilingual Services</h3>
            <p>Professional medical interpreters and international patient services</p>
          </div>
          <div className="feature-card">
            <Users className="feature-icon" />
            <h3>Expert Medical Teams</h3>
            <p>Internationally trained specialists with extensive experience</p>
          </div>
          <div className="feature-card">
            <Clock className="feature-icon" />
            <h3>Efficient Care</h3>
            <p>Minimal waiting times and streamlined medical procedures</p>
          </div>
          <div className="feature-card">
            <Stethoscope className="feature-icon" />
            <h3>Specialized Treatment</h3>
            <p>Comprehensive range of medical specialties and treatments</p>
          </div>
        </div>
      </section>

      {/* Services Section */}
      <section className="services-section">
        <div className="container">
          <h2>Our Medical Services</h2>
          <div className="services-grid">
            <div className="service-card">
              <img 
                src="https://images.unsplash.com/photo-1579684385127-1ef15d508118?auto=format&fit=crop&q=80&w=1000"
                alt="Health Screening"
                loading="lazy"
              />
              <div className="service-content">
                <h3>Health Screening</h3>
                <p>Comprehensive health check-ups with advanced diagnostic equipment</p>
              </div>
            </div>
            <div className="service-card">
              <img 
                src="https://images.unsplash.com/photo-1631815588090-d4bfec5b1b98?auto=format&fit=crop&q=80&w=1000"
                alt="Surgical Procedures"
                loading="lazy"
              />
              <div className="service-content">
                <h3>Surgical Procedures</h3>
                <p>Minimally invasive and advanced surgical treatments</p>
              </div>
            </div>
            <div className="service-card">
              <img 
                src="https://images.unsplash.com/photo-1666214280557-f1b5022eb634?auto=format&fit=crop&q=80&w=1000"
                alt="Specialty Care"
                loading="lazy"
              />
              <div className="service-content">
                <h3>Specialty Care</h3>
                <p>Specialized medical treatments across various disciplines</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Contact Section */}
      <section className="contact-section container">
        <div className="contact-content">
          <div className="contact-text">
            <h2>Start Your Medical Journey</h2>
            <p>
              Our dedicated international patient center is here to assist you with 
              planning your medical trip to Taipei. From appointment scheduling to 
              travel arrangements, we ensure a seamless healthcare experience.
            </p>
            <div className="contact-info">
              <p>Email: contact@taipeimedical.com</p>
              <p>International Hotline: +886-2-1234-5678</p>
            </div>
          </div>
          <div className="contact-image">
            <img 
              src="https://images.unsplash.com/photo-1623377832560-dee3927e2ea5?auto=format&fit=crop&q=80&w=1000"
              alt="Medical Consultation"
              loading="lazy"
            />
          </div>
        </div>
      </section>
    </div>
  );
};

export default Taipeiims;